import { TreeItem } from './item';
import { Dossier } from '../dossier';
import { RootItem } from './root-item';
import { DossierModel } from '../../dossier-model/dossier-model';

export type VisitFn = (item: TreeItem) => any;

export class DossierTree {

  readonly dossier: Dossier
  readonly dossierModel: DossierModel

  rootItem: RootItem
  selectedItem: TreeItem

  constructor(dossier: Dossier, dossierModel: DossierModel) {
    this.dossier = dossier;
    this.dossierModel = dossierModel;

    this.rootItem = new RootItem(this);
    this.selectedItem = this.rootItem;
  }

  isLinkSelected(item: TreeItem): boolean {
    return this.selectedItem === item;
  }

  visit(fn: VisitFn) {
    this.rootItem.visit(fn);
  }
}